import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const Checkbox = ({
  checkboxLabel,
  checked,
  containerClassName,
  custom,
  disabled,
  horizontal,
  id,
  inputClassName,
  name,
  required,
  value,
  ...rest
}) => {
  const inputClasses = cn('c-checkbox', inputClassName);
  const containerClasses = cn(
    'c-checkbox__container',
    {
      'o-grid__item o-grid__item--shrink  u-margin-bot-none': horizontal,
    },
    { custom },
    containerClassName
  );
  const labelName = name.replace(
    /([A-Z])/g,
    (match) => ` ${match.toLowerCase()}`
  );

  const optionalLabel = () => {
    if (checkboxLabel) {
      return (
        <label className="c-form__label c-form__label--checkbox" htmlFor={id}>
          {checkboxLabel}
          {required && (
            <abbr className="c-form__required" title="Required">
              *
            </abbr>
          )}
        </label>
      );
    }

    return (
      <label
        className="c-form__label c-form__label--checkbox u-hide-visually"
        htmlFor={id}
      >
        {labelName}
      </label>
    );
  };

  return (
    <div className={containerClasses}>
      <input
        checked={checked}
        className={inputClasses}
        disabled={disabled}
        id={id}
        name={name}
        type="checkbox"
        value={value}
        tabIndex={custom ? '-1' : '0'}
        {...rest}
      />
      {optionalLabel()}
      {custom && (
        <span
          className="checkmark"
          tabIndex="0"
          role="checkbox"
          aria-checked={checked}
          aria-label={labelName}
          onKeyPress={rest.onChange}
          onClick={rest.onChange}
        />
      )}
    </div>
  );
};

export default Checkbox;

Checkbox.propTypes = {
  checked: PropTypes.bool,
  containerClassName: PropTypes.string,
  custom: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  inputClassName: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  value: PropTypes.oneOf([PropTypes.bool, PropTypes.string]),
};

Checkbox.defaultProps = {
  checked: false,
  containerClassName: '',
  custom: false,
  disabled: false,
  inputClassName: '',
  label: '',
  required: false,
};
